import { Chip, FormControl, TextField, Checkbox, Autocomplete } from '@mui/material'
import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { grey } from "@mui/material/colors";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CloseIcon from "@mui/icons-material/Close";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const FormCustomerSelectRuleEdit = memo((props) => {
  const { setNames, names, name } = props
  const { deleteMode } = useSelector(state => state.contractsCatalog)

  const handleChangeSelectedClients = (e, v) => {
    const isAll = v.find(val => val.value === "all");
    if(isAll) {
      setNames(names.map(item => {
        if (item.id === name.id) return {...item, selectedClients: [{id: '1234', value: 'all', label: 'Todos los resultados'}, ...name.options] }
        else return item
      }))
    } else {
      setNames(names.map(item => {
        if (item.id === name.id) return {...item, selectedClients: v }
        else return item
      }))
    }
  }

  return (
    <>
      <FormControl fullWidth style={{marginTop: 20}}>
        <Autocomplete
          options={
            name.options.length < name.selectedClients.length
            ? [...name.selectedClients] 
            : [{id: '1234', value: 'all', label: 'Todos los resultados'}, ...name.options]
          }
          getOptionLabel={(rule) => rule.label}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Grupo de clientes"
              variant="outlined"
            />
          )}
          fullWidth
          onChange={(e, v) => handleChangeSelectedClients(e, v)}
          value={name.selectedClients}
          limitTags={1}
          multiple
          renderTags={(value, getTagProps) =>
            value?.map((option, index) => (
              <Chip
                variant="outlined"
                label={option?.label ? option.label : option.name}
                {...getTagProps({ index })}
                style={{
                  maxWidth: '80%',
                  borderRadius: 1,
                  fontSize: 10,
                  border: `2px solid ${grey[500]}`,
                }}
              />
            ))
          }
          renderOption={(option, { selected }) => (
            <React.Fragment>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
                color="primary"
              />
              {option.label}
            </React.Fragment>
          )}
          closeIcon={
            <CloseIcon
              fontSize="small"
              style={{
                color: 'black',
              }}
            />
          }
          disabled={deleteMode}
        />
      </FormControl>
    </>
  )
})
